import { jsxs as i, jsx as o, Fragment as p } from "react/jsx-runtime";
import { x as r, y as f } from "../../vendor--aJiswR_.js";
import { forwardRef as h } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as l } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as c } from "../BaseIcon/index.js";
import '../../assets/index13.css';const x = "_checkboxWrapper_1so1m_1", k = "_checkbox_1so1m_1", _ = "_indicator_1so1m_34", e = {
  checkboxWrapper: x,
  checkbox: k,
  indicator: _
}, W = h(
  ({ children: t, labelRef: s, variant: n = "checkbox", ...m }, a) => {
    const b = r(a), d = r(s);
    return /* @__PURE__ */ i(
      f,
      {
        ...l(m),
        slot: void 0,
        ref: d,
        inputRef: b,
        className: e.checkboxWrapper,
        "data-component": "Checkbox",
        children: [
          /* @__PURE__ */ o("div", { className: e.checkbox, "aria-hidden": !0, children: n === "visibility" ? /* @__PURE__ */ i(p, { children: [
            /* @__PURE__ */ o(c, { size: "sm", color: "moon", icon: "visibility-checked" }),
            /* @__PURE__ */ o(c, { size: "sm", color: "moon", icon: "visibility-unchecked" }),
            /* @__PURE__ */ o(c, { size: "sm", color: "moon", icon: "visibility-indeterminate" })
          ] }) : /* @__PURE__ */ o("div", { className: e.indicator }) }),
          t
        ]
      }
    );
  }
);
export {
  W as Checkbox
};
//# sourceMappingURL=index.js.map
